// extracted by mini-css-extract-plugin
export default {"vote":"index_vote_fov5S","voted":"index_voted_QP2ZG"};